import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {ButtonVariantsEnum} from '../../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {buildAddInboxSettingsPath, buildTeamPath} from '../../../../../helpers/modelHelpers';
import {InboxesFiltersEnum, TeamsFoldersEnum} from '../../../../../models/url/inboxesUrlModel';
import {IntegrationIconsEnum} from '../../../../common/integrationIcon';
import {
  CellsEmptySetupActionsProps,
  StyledCellsEmptySetupActionsContentDiv,
  StyledCellsEmptySetupActionsSubTitleDiv,
  StyledCellsEmptySetupActionsTitleDiv,
  StyledCellsEmptySetupActionsWrapperDiv,
} from './cellsEmptyCommon';
import {CellsEmptySetupActionsButton} from './cellsEmptySetupActionsButton';
import {CellsEmptySetupActionsDismissButton} from './cellsEmptySetupActionsDismissButton';
import {CellsEmptySetupActionsLink} from './cellsEmptySetupActionsLink';

/*
 * Props.
 */

interface CellsEmptyTeammateSetupActionsProps extends CellsEmptySetupActionsProps {
  shouldShowAddTeamInbox: boolean;
  teamId?: number;
  selectedFilter?: InboxesFiltersEnum;
}

/*
 * Component.
 */

export const CellsEmptyTeammateSetupActions: FC<CellsEmptyTeammateSetupActionsProps> = (props) => (
  <StyledCellsEmptySetupActionsWrapperDiv>
    <StyledCellsEmptySetupActionsContentDiv>
      <StyledCellsEmptySetupActionsTitleDiv>
        <Trans id="cells-empty-cta-teammate-title">Add your work email</Trans>
      </StyledCellsEmptySetupActionsTitleDiv>
      <StyledCellsEmptySetupActionsSubTitleDiv>
        <Trans id="cells-empty-cta-teammate-subtitle">
          Once you&apos;ve connected inboxes, all your messages will appear here.
        </Trans>
      </StyledCellsEmptySetupActionsSubTitleDiv>
      {props.namespace && (
        <>
          <CellsEmptySetupActionsButton
            buttonVariant={ButtonVariantsEnum.PRIMARY}
            interactionId="cells-empty-cta-teammate-googlebutton"
            title={<Trans id="cells-empty-cta-teammate-googlebutton">Add with Google</Trans>}
            integrationIcon={IntegrationIconsEnum.GOOGLE}
            onClick={props.navigate(
              `${buildAddInboxSettingsPath(props.namespace)}?channelType=email&triggerOAuthType=google`,
            )}
          />
          <CellsEmptySetupActionsButton
            buttonVariant={ButtonVariantsEnum.PRIMARY}
            interactionId="cells-empty-cta-teammate-microsoftbutton"
            title={<Trans id="cells-empty-cta-teammate-microsoftbutton">Add with Microsoft</Trans>}
            integrationIcon={IntegrationIconsEnum.MICROSOFT}
            onClick={props.navigate(
              `${buildAddInboxSettingsPath(props.namespace)}?channelType=email&triggerOAuthType=office365`,
            )}
          />
          <CellsEmptySetupActionsButton
            buttonVariant={ButtonVariantsEnum.SECONDARY}
            interactionId="cells-empty-cta-teammate-otherbutton"
            title={<Trans id="cells-empty-cta-teammate-otherbutton">Other email client</Trans>}
            onClick={props.navigate(`${buildAddInboxSettingsPath(props.namespace)}?channelType=email`)}
          />
        </>
      )}
      {props.shouldShowAddTeamInbox && props.teamId && props.selectedFilter && (
        <CellsEmptySetupActionsLink
          interactionId="cells-empty-cta-teammate-teaminboxlink"
          title={<Trans id="cells-empty-cta-teammate-teaminboxlink">Add a team inbox</Trans>}
          onClick={props.navigate(buildTeamPath(props.teamId, TeamsFoldersEnum.INBOX, props.selectedFilter))}
        />
      )}
    </StyledCellsEmptySetupActionsContentDiv>
    <CellsEmptySetupActionsDismissButton
      interactionId="cells-empty-cta-teammate-dismissbutton"
      onClick={props.onDismissClick}
    />
  </StyledCellsEmptySetupActionsWrapperDiv>
);
